// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".entity_top_decisions-module__container--79id0{display:block;margin-top:24px;margin-bottom:24px}.entity_top_decisions-module__item--1dYMs{font-weight:400;font-size:16px;line-height:24px;letter-spacing:0px;cursor:pointer}.entity_top_decisions-module__item--1dYMs:hover{text-decoration:underline}.entity_top_decisions-module__label--1xWAA{font-weight:400;font-size:14px;line-height:21px;letter-spacing:0}.entity_top_decisions-module__icon--2gapu{vertical-align:middle;font-size:inherit;line-height:inherit;padding:0 5px}@media screen and (max-width: 48em){.entity_top_decisions-module__icon--2gapu{display:none}}\n", ""]);
// Exports
exports.locals = {
	"container": "entity_top_decisions-module__container--79id0",
	"item": "entity_top_decisions-module__item--1dYMs",
	"label": "entity_top_decisions-module__label--1xWAA",
	"icon": "entity_top_decisions-module__icon--2gapu"
};
module.exports = exports;
